import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Image from '../../../components/AppImage';

const RecommendedProducts = ({ onAddToCart }) => {
  const recommendedProducts = [
    {
      id: 101,
      name: "Organic Avocados",
      price: 5.99,
      originalPrice: 7.99,
      discount: 25,
      image: "https://images.unsplash.com/photo-1523049673857-eb18f1d7b578?w=300&h=300&fit=crop",
      category: "Fruits",
      rating: 4.8,
      stock: 25
    },
    {
      id: 102,
      name: "Greek Yogurt",
      price: 4.29,
      image: "https://images.unsplash.com/photo-1571212515416-fca0bf4c4cda?w=300&h=300&fit=crop",
      category: "Dairy",
      rating: 4.6,
      stock: 40
    },
    {
      id: 103,
      name: "Organic Spinach",
      price: 3.49,
      image: "https://images.unsplash.com/photo-1576045057995-568f588f82fb?w=300&h=300&fit=crop",
      category: "Vegetables",
      rating: 4.7,
      stock: 30
    },
    {
      id: 104,
      name: "Almond Butter",
      price: 8.99,
      originalPrice: 10.99,
      discount: 18,
      image: "https://images.unsplash.com/photo-1571115764595-644a1f56a55c?w=300&h=300&fit=crop",
      category: "Pantry",
      rating: 4.9,
      stock: 15
    }
  ];

  const handleAddToCart = (product) => {
    const cartItem = {
      ...product,
      quantity: 1
    };
    onAddToCart(cartItem);
  };

  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;

    for (let i = 0; i < fullStars; i++) {
      stars.push(
        <Icon key={i} name="Star" size={12} className="text-warning fill-current" />
      );
    }

    if (hasHalfStar) {
      stars.push(
        <Icon key="half" name="Star" size={12} className="text-warning fill-current opacity-50" />
      );
    }

    const remainingStars = 5 - Math.ceil(rating);
    for (let i = 0; i < remainingStars; i++) {
      stars.push(
        <Icon key={`empty-${i}`} name="Star" size={12} className="text-border" />
      );
    }

    return stars;
  };

  return (
    <div className="bg-surface border border-border rounded-card p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="font-heading font-heading-semibold text-xl text-text-primary">
          You might also like
        </h3>
        <Icon name="Sparkles" size={20} className="text-primary" />
      </div>

      <div className="space-y-4">
        {recommendedProducts.map((product) => (
          <div key={product.id} className="flex items-center space-x-4 p-4 bg-background rounded-input hover:shadow-card transition-smooth">
            {/* Product Image */}
            <div className="flex-shrink-0">
              <div className="w-16 h-16 overflow-hidden rounded-input">
                <Image
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            {/* Product Details */}
            <div className="flex-1 min-w-0">
              <p className="text-xs text-text-secondary mb-1">{product.category}</p>
              <h4 className="font-body-semibold text-sm text-text-primary mb-1 truncate">
                {product.name}
              </h4>
              
              {/* Rating */}
              <div className="flex items-center space-x-1 mb-2">
                <div className="flex items-center space-x-0.5">
                  {renderStars(product.rating)}
                </div>
                <span className="text-xs text-text-secondary">({product.rating})</span>
              </div>

              {/* Price */}
              <div className="flex items-center space-x-2">
                <span className="font-data font-data-medium text-primary">
                  ${product.price.toFixed(2)}
                </span>
                {product.originalPrice && (
                  <>
                    <span className="text-xs text-text-secondary line-through">
                      ${product.originalPrice.toFixed(2)}
                    </span>
                    <span className="bg-accent text-accent-foreground text-xs px-1.5 py-0.5 rounded-input">
                      {product.discount}% OFF
                    </span>
                  </>
                )}
              </div>
            </div>

            {/* Add Button */}
            <div className="flex-shrink-0">
              <Button
                variant="primary"
                onClick={() => handleAddToCart(product)}
                className="w-8 h-8 p-0"
                iconName="Plus"
                iconSize={16}
              />
            </div>
          </div>
        ))}
      </div>

      {/* View More */}
      <div className="mt-6 text-center">
        <Button
          variant="outline"
          iconName="ArrowRight"
          iconPosition="right"
          className="w-full"
        >
          View More Products
        </Button>
      </div>
    </div>
  );
};

export default RecommendedProducts;